export default {
  message: {
    Tour: {
      continue: "Continuar",
      back: "Atrás",
      finish: "Finalizar"
    },
    Login: {
      title: "Inicio de sesión de los padres",
      sign_in: "Iniciar sesión",
      login_fail:
        "Autenticación fallida. Vuelva a intentarlo o comuníquese con su escuela para obtener ayuda para iniciar sesión.",
      forgot_password: "Has olvidado tu contraseña",
      create_account: "Crear una cuenta",
      password: "Contraseña",
      confirm_password: "Confirmar Contraseña",
      password_reminder: "Recordatorio de contraseña",
      enter_email: "Ingrese su dirección de correo electrónico",
      validation_error: "Mensaje de error de validación",
      password_reminder_error_no_user_register:
        "No se pudo encontrar el nombre de usuario ingresado. Inténtelo nuevamente o cree una cuenta nueva.",
      password_reminder_error_no_user: "No se pudo encontrar el nombre de usuario ingresado.",
      password_reminder_sent:
        "Se ha enviado un correo electrónico con más instrucciones a {email}.",
      password_reminder_sent_message:
        "El correo electrónico puede tardar unos minutos en llegar. Si no lo ve en su bandeja de entrada, verifique su carpeta de correo no deseado.",
      password_trouble_email: "Si aún tiene problemas, comuníquese con {email}.",
      password_trouble_school:
        "Si aún tiene problemas, comuníquese con su escuela para obtener ayuda.",
      return_to_sign_in: "Atrás para iniciar sesión",
      create_my_account: "Crear mi cuenta",
      or_sign_in_with: "O INICIAR SESIÓN CON",
      password_reset: "Elija una nueva contraseña para su cuenta.",
      password_reset_warning:
        "Si no solicitó cambiar su contraseña, comuníquese con el administrador de su escuela de inmediato.",
      password_update: "Elija una nueva contraseña",
      password_update_confirm: "Confirmar nueva contraseña",
      password_update_success: "Su nueva contraseña ha sido guardada."
    },
    AccountSettings: {
      title: "Configuraciones",
      first_name: "Nombre",
      last_name: "Apellido",
      email: "Correo electrónico",
      username: "Nombre de usuario",
      password: "Contraseña",
      students: "Estudiantes",
      teachers: "Profesores",
      external_id: "Identificación externa",
      phone: "teléfono",
      edit: "Edit",
      remove: "Eliminar",
      add: "Add",
      remove_message: "¿Está seguro de que desea eliminar el nombre de este estudiante?",
      yes: "Sí",
      no: "No",
      add_student: "Agregar estudiante",
      close: "Cerrar",
      save: "Guardar cambios",
      cancel: "Cancelar",
      student_alert_message: "Debe ingresar al menos un nombre de estudiante.",
      logout: "Cerrar Sesión"
    },
    Navbar: {
      my_meetings: "Mis Reuniones",
      language: "Spanish",
      help: "Ayuda",
      account_settings: "Configuraciones",
      logout: "Cerrar Sesión"
    },
    SubNavbar: {
      meeting: "Cita",
      event: "Evento",
      print: "Imprimir",
      email: "Correo electrónico",
      export: "Exportar"
    },
    ConferenceCard: {
      add_edit_meetings: "Agregar/Editar Citas",
      opening: "Abierto",
      closed: "Cerrado"
    },
    Agenda: {
      full_agenda: "Agenda Completa",
      empty_state_title: "No pudimos encontrar ninguna conferencia para usted.",
      empty_state_message:
        "Si tiene alguna pregunta, comuníquese con el representante de su escuela.",
      confirmation_modal_title: "Agenda Confirmada",
      confirmation_modal_message:
        "Su agenda ha sido confirmada exitosamente y se le ha enviado un correo electrónico.",
      complete_button: "¡Terminado!"
    },
    AgendaCard: {
      room: "Cuarto no disponible",
      room_with_value: "Cuarto: {room}",
      virtual_meeting: "Reunión Virtual",
      all_conferences: "Todos los Eventos",
      conference: "Conferencia",
      student: "Estudiante",
      meeting_with: "Reunirse Con",
      date_time: "Fecha y hora",
      meeting_type: "Tipo de Reunión",
      location: "Ubicación",
      comment: "Comentario",
      action: "Acción",
      delete: "Eliminar",
      add_comment: "Agregar Comentario",
      join: "Unirse a la reunión",
      choose_meeting_type: "Elija el tipo de reunión",
      in_person: "En persona",
      phone: "Teléfono",
      callback: "Llamar de vuelta",
      virtual: "Virtual",
      unavailable: "No disponible",
      tooltip_translator:
        "El servicio de traducción no está garantizado, pero la escuela hará todo lo posible para que esté disponible.",
      translator_requested: "{language} intérprete solicitado",
      clear_translator: "Borrar solicitud de intérprete",
      need_translator: "¿Necesita un intérprete?",
      choose_language: "Elija un idioma"
    },
    ScheduleMatrix: {
      no_teachers_title: "No se seleccionan profesores o equipos.",
      no_teachers_message: "Elija un profesore para ver los horarios de sus reuniones.",
      choose_teachers_button: "Ver profesores o equipos disponibles",
      choose_student: "¿Para qué estudiante?",
      cancel: "Cancelar"
    },
    Matrix: {
      teachers: "Profesor",
      agenda: "Revisar y continuar"
    },
    DrawerTeachers: {
      teachers: "Profesores",
      name: "Nombre",
      description: "Descripción",
      student: "Estudiante",
      teacher_team: "Profesor / equipo",
      show_more: "Mostrar más maestros",
      show_all: "Mostrar todos los profesores de la escuela.",
      selected: "({count}) seleccionado",
      closeDrawer: "Continuar programando",
      search: "Buscar un profesor o equipo",
      not_available: "Este profesor no tiene horarios disponibles para el {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "No tienes reuniones programadas.",
      no_meetings_message: "Una vez que hayas elegido un profesor y un horario, aparecerá aquí.",
      new_meeting_label: "Nuevo",
      cancel_button: "Cancelar",
      student_label: "Estudiantes",
      meeting_type_location: "Tipo de reunión/Ubicación",
      comment_label: "Comentario",
      save_comment_button: "Guardar comentario",
      confirm_label: "Por favor confirmar:",
      confirm_cancel_button: "Sí, cancelar mi reunión con ",
      do_not_cancel_button: "No Cancelar",
      confirm_agenda_button: "Confirmar esta agenda",
      confirm_agenda_message_line1: "Siempre puedes regresar y hacer cambios.",
      confirm_agenda_message_line2: "Su agenda actual le será enviada por correo electrónico."
    },
    EmailConsent: {
      message:
        "En un esfuerzo por proteger su privacidad y seguridad, requerimos su consentimiento para recibir comunicaciones de nuestro sistema en su dirección de correo electrónico.",
      consent: "Consentir"
    }
  }
};
